import React from "react";

interface CircleInfoProps {
  size?: number | string;
  className?: string;
  color?: string;
}

const CircleInfo: React.FC<CircleInfoProps> = ({
  size = 24,
  className,
  color = "#F7F9F9",
}) => {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7 8H6V6H9V11H10V13H7V8ZM9 5V3H7V5H9Z"
        fill={color}
      />
    </svg>
  );
};

export default CircleInfo;
